import useApi from '../useApi';
import { useShowSnackbar } from '../useShowSnackbar';

export const useCreatePartners = () => {
  const showSnackbar = useShowSnackbar();

  const { data, loading, postData } = useApi('/BlazorApi/submitdsppartners');

  const createPartners = async (body) => {
    const res = await postData(body);
    if (res.status === true) {
      showSnackbar(res?.message ?? '');
    } else {
      showSnackbar(res?.message ?? res?.title ?? '', 'error');
    }
    return res;
  };

  return { data, loading, createPartners };
};
